const all = ['report-text-templates'] as const;

const findMany = () => {
  return [...all, 'list'] as const;
};

const findOne = (key: string) => {
  return [...all, key] as const;
};

export const reportTextTemplateKeys = {
  all,
  findMany,
  findOne,
};
